import styled from 'styled-components';

export const WrapGallery = styled.section`
    ${({ theme }) => theme.spacing.articleBody}
    display: flex;
    flex-wrap: wrap;
    gap: .5em;
    justify-content: center;

    @media (min-width: 601px){
        .medio {
            width: calc(50% - 0.5em);
        }

        .pequeno {
            width: calc(33% - 0.5em);
        }
    }
    
`;
